//全部期限下拉
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import { Dropdown, Menu } from "antd";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data = "all", callback, className, props = {} }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const keyLabelObj = useMemo(() => {
    return {
      ALL: t("finance.allDuration"),
      FLEXIBLE: t("finance.flexible"),
      FIX: t("finance.fixed"),
    };
  }, []);

  return (
    <Dropdown
      overlay={
        <Menu
          selectable={true}
          selectedKeys={[data]}
          items={[
            {
              key: "ALL",
              label: <a onClick={() => callback && callback("ALL")}>{keyLabelObj.ALL}</a>,
            },
            {
              key: "FLEXIBLE",
              label: <a onClick={() => callback && callback("FLEXIBLE")}>{keyLabelObj.FLEXIBLE}</a>,
            },
            {
              key: "FIX",
              label: <a onClick={() => callback && callback("FIX")}>{keyLabelObj.FIX}</a>,
            },
          ]}
        ></Menu>
      }
      {...props}
    >
      <button className={cx("btntxt", styles.trigger, className)}>{keyLabelObj[data]}</button>
    </Dropdown>
  );
});
